import {useMutation, UseMutationResult} from '@tanstack/react-query';
import {useLocale} from 'state/locale';
import Api from 'types/api';
import {toSnakeCase} from 'utils/object';
import {request} from 'utils/request-axios';

type PossibleResponses = Api.Response.SuccessAxios;

const useSendingSettings = (): UseMutationResult<
    PossibleResponses,
    Error,
    unknown
> => {
    const locale = useLocale();

    return useMutation((formData) =>
        request({
            formData: toSnakeCase(formData),
            locale,
            method: 'POST',
            url: window.Urls.partner_sending_settings_view(),
        }),
    );
};

export default useSendingSettings;
